// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-merge-panel-header {
  display: flex;
  flex-direction: column;
  margin-top: 5.7rem;
  margin-bottom: 4.7rem;
  gap: 1.5rem;
}
.work-merge-panel-header h4 {
  align-self: center;
  justify-content: center;
}
.work-merge-panel-header p {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergePrimarySelection/WorkMergePrimarySelectionHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;EACA,uBAAA;AACJ;AAEE;EACE,eAAA;AAAJ","sourcesContent":[".work-merge-panel-header {\n  display: flex;\n  flex-direction: column;\n  margin-top: 5.7rem;\n  margin-bottom: 4.7rem;\n  gap: 1.5rem;\n\n  h4 {\n    align-self: center;\n    justify-content: center;\n  }\n\n  p {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
